import { createContext, useContext } from 'react';

import { DEFAULT_LEGEND } from '../types/default.js';
import { PieChartLegendConfig } from '../types/pie-chart.config.js';

export const ChartLegendContext =
  createContext<PieChartLegendConfig>(DEFAULT_LEGEND);

export const useChartLegend = () => useContext(ChartLegendContext);

ChartLegendContext['displayName'] = 'ChartLegendContext';
